import loginService from './loginService';
import menuService from './menuService';
import cacheService from './cacheService';
// import authInfoService from './authInfoService';

export default {
  async login(userId, password) {
    try {
      const loginResponse = await loginService.login(userId, password);
      return loginResponse;
    } catch (err) {
      console.error(err);
    }
  },
  async loginEpTray(epTrayKey) {
    try {
      const loginResponse = await loginService.loginEpTray(epTrayKey);
      return loginResponse;
    } catch (err) {
      console.error(err);
    }
  },

  logout() {
    loginService.logout();
  },
  async getMenus(forceRemote = false) {
    return menuService.getMenus(forceRemote);
  },
  clearCache() {
    cacheService.clearCache();
  },
  // async getAuthInfo() {
  //   try {
  //     const res = await authInfoService.getMyAuth();
  //     return res;
  //   } catch (err) {
  //     console.error(err);
  //   }
  // },
};



// WEBPACK FOOTER //
// ./src/service/index.js